// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Xv3","question":"styles_question__2LTnT","inputVisibleButton":"styles_inputVisibleButton__1p7oq","note":"styles_note__zI-Yx"};